import Vue from 'vue'
import 'es6-promise/auto'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import * as resources from './resources'
import resource from './plugins/resource'
import deviceQueries from './plugins/device-queries'
import Pace from 'pace-progress'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faSearch, faCoffee, faMapMarker, faPhone, faMailBulk} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import BootstrapVue from 'bootstrap-vue'
import Inview from 'vueinview'

library.add(faSearch)
library.add(faCoffee)
library.add(faMapMarker)
library.add(faPhone)
library.add(faMailBulk)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(Inview)
Vue.use(resource, {
  resources,
  endpoint: '/static/api'
})

Vue.use(deviceQueries, {
  phone: 'max-width: 567px',
  tablet: 'min-width: 568px',
  mobile: 'max-width: 1024px',
  laptop: 'min-width: 1025px',
  desktop: 'min-width: 1280px',
  monitor: 'min-width: 1448px'
})

new Vue({
  router,
  render: h => h(App),
  mounted() {
    Pace.start()
    Pace.on('hide', () => {
      setTimeout(function () {
        document.dispatchEvent(new Event('app.rendered'));
      }, 2000)
    })
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js